export const host = () => {
    const SESSION_STORAGE_KEY = 'identityClientH';
    const url = btoa(`${window.location.protocol}//${window.location.host}`);
    sessionStorage.setItem(SESSION_STORAGE_KEY, url);
    return url
}